<template>
    <div>
        <div class="print-wrapper-fixed">
            <div class="print-wrapper-body">
                <headerDefault/>
                <div class="data-list-wrap">
                    <div class="dl-title"><strong>输入参数</strong></div>
                    <div class="dl-item" v-for="(item,key,index) in cs" :key="key">
                        <span>{{item.name}}</span>
                        <span>{{item.value}}{{item.label.includes('%') ? '%' : ''}}</span>
                    </div>
                </div>
                <div class="data-list-wrap">
                    <div v-for="(item,key,index) in set"
                         :key="key"
                         :class="item.type === 'section-title' ? 'dl-title' : 'dl-item'">
                        <template v-if="item.type === 'section-title'"><strong>{{item.name}}</strong></template>
                        <template v-else>
                            <span>{{item.name}}</span>
                            <span>{{item.value}}</span>
                        </template>
                    </div>
                </div>
                <div class="data-list-wrap">
                    <div class="dl-title"><strong>输出参数</strong></div>
                </div>
                <div class="chart-img">
                    <img :src="img" alt="">
                </div>
                <div v-html="rt" class="right-table"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import headerDefault from './header-default'

    export default {
        name: "PRINT",
        props: {
            set: Object,
            cs: Object,
            img: String,
            rt: String,
        },
        data() {
            return {}
        },
        components: {headerDefault},
        created() {
        },
        methods: {},
    }
</script>

<style lang="scss">
    .print-wrapper-fixed {
        width: 100%;
        margin: 0 auto;
        min-height: 100vh;
        background-color: #fff;
        color: #000;

        .print-wrapper-body {
            max-width: 210mm;
            width: 100%;
            display: block;
            margin: 0 auto;
            background-color: #fff;

            .header {
                .wp {
                    padding: 0;
                    margin: 0;
                    width: 100%;
                }
            }
        }

        .data-list-wrap {
            display: flex;
            flex-wrap: wrap;

            .dl-title {
                margin-top: 20px;
                flex: 0 0 100%;
                background-color: #f7f8fb;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px;
                font-size: 14px;
                height: 50px;
            }

            .dl-item {
                margin-top: 0;
                @extend .dl-title;
                flex: 0 0 50%;
                background-color: #fff;

                &:nth-of-type(4n) {
                    border-right: 5px solid #fff;
                    padding-right: 15px;
                    background-color: #f7f8fb;

                    & + .dl-item {
                        padding-left: 15px;
                        background-color: #f7f8fb;
                        border-left: 5px solid #fff;
                    }
                }
            }
        }

        .chart-img {
            display: block;

            img {
                display: block;
                width: 100%;
            }
        }
    }
</style>
